import Btn from "../utils/btn";

const func = $target => {

    var $timezoneCheckBox = document.querySelectorAll('input.timezone-checkbox-group'),
        $templateTolerance = document.querySelectorAll('input.template-tolerance-group'),
        $btn = new Btn($target.find('button[type="submit"]')),
        $radioInput = $target.find('.radioInput'),
        $surgeryBrand = $target.find('#surgeryBrand'),
        $surgeryKitTextBox = $target.find('#surgeryKitTextBox'),
        $originalAnchorPins = $target.find('#originalAnchorPins'),
        $anchorPinsTextBox = $target.find('#anchorPinsTextBox'),
        $productType = $target.find('.productType').data('type'),
        $scheduleSurgeryBrand = $target.find('#scheduleSurgeryBrand'),
        days = 0 ;

    $productType === 'clicGuideDoctorManufacture' ? days = 15 : days = 7;
    var today = new Date(),
        result = today.setDate(today.getDate() + days),
        minDate = new Date(result).toISOString().split('T')[0];

    $('.scheduleSurgeryYes').on('click',function () {
        $('input[name="clicGuidescheduleSurgeryBrand"]').attr('min',minDate);
    })
    $scheduleSurgeryBrand.attr('onkeydown','return false')

    $surgeryBrand.on('change',function () {
        if ($(this).val() == 'OTHER') {
            $(this).attr('name','')
            $surgeryKitTextBox.removeClass("d-none");
            $('#surgeryKit').attr('required',true).attr('name','clicGuideSurgeryKit')
            $surgeryKitTextBox.focus();
        } else {
            $('#surgeryKit').attr('required',false).attr('name','')
            $(this).attr('name','clicGuideSurgeryKit')
            $surgeryKitTextBox.addClass("d-none");
        }
    })
    $originalAnchorPins.on('change',function () {
        if ($(this).val() == 'Other') {
            $(this).attr('name','')
            $anchorPinsTextBox.removeClass("d-none");
            $('#anchorPinText').attr('required',true).attr('name','clicGuideAnchorPins')
            $anchorPinsTextBox.focus();
        } else {
            $(this).attr('name','clicGuideAnchorPins')
            $('#anchorPinText').attr('required',false).attr('name','')
            $anchorPinsTextBox.addClass("d-none");
        }
    })

    $radioInput.click(function (){
        var $value = $(this).val(),
            $name = $(this).attr('name'),
            $selectedAns = $('.'+$name+$value+'');

        $('.invalid-'+$name).css('display','none')
        $selectedAns.removeClass('d-none');
        $selectedAns.find( '#'+$name+'Brand').attr('required',true)
        $selectedAns.find( '#'+$name+'Brand').attr('name','clicGuide'+$name+'Brand')
        if ($value == 'Yes'){
            $('.'+$name+'No').addClass('d-none');
            $('.'+$name+'No').find( '#'+$name+'Brand').removeAttr('required');
            $('.'+$name+'No').find( '#'+$name+'Brand').removeAttr('name');
        } else {
            $('.'+$name+'Yes').addClass('d-none');
            $('.'+$name+'Yes').find( '#'+$name+'Brand').removeAttr('required');
            $('.'+$name+'Yes').find( '#'+$name+'Brand').removeAttr('name');
        }
    })

    for (var k=0;k<$timezoneCheckBox.length;k++){
        $timezoneCheckBox[k].onclick = function () {
            var timezone_error = $('.timezone-checkbox-error');
            if (this.checked){
                timezone_error.hide();
            }
        }
    }
    for (var j = 0;j<$templateTolerance.length;j++){
        $templateTolerance[j].onclick = function () {
            var tolerance_error = $('.invalid-templateTolerance');
            if (this.checked){
                tolerance_error.hide();
            }
        }
    }
    function validateRadio(radioInput,e) {
        e.preventDefault()
        $('.invalid-'+radioInput).css('display','block')
        $btn.processed();
        return false;
    }
    $target.on('submit',function (e) {
        var timezone_error = $('.timezone-checkbox-error'),
            timezone_checked = $("[name='clicGuideTimezone[]']:checked").length,
            scheduleSurgery = $("input[name='scheduleSurgery']:checked").length,
            templateToleranceRadio = $("input[name='templateTolerance']:checked"),
            templateTolerance = $("input[name='clicGuideTemplateTolerance']:checked").length;

        if ($('.radioInput').length){
            if (scheduleSurgery == 0){
                validateRadio('scheduleSurgery',e)
            }if (templateToleranceRadio.length > 0 && templateTolerance == 0 && templateToleranceRadio.val() == 'Yes') {
                validateRadio('templateTolerance', e)
            }if (templateToleranceRadio.val() == 'No'){
                $("input[name='clicGuideTemplateTolerance']").prop('checked',false)
            }
        }
        if (($timezoneCheckBox).length){
            if(timezone_checked == 0) {
                timezone_error.show();
                $btn.processed();
                return false;
            }
        }
    })
};

export default func;